import React from 'react';
import classnames from 'classnames';
import styles from './LoadingMask.scss';
const LoadingMask = ({ active, children }) => (<div className={classnames(styles.clear, { [styles.mask]: active })}>
    {children}
  </div>);
export default LoadingMask;
